import React, { useEffect, useState } from 'react'

const LoadingDots = ({loadingText}) => {
    const [dots, setDots] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prevDots) => (prevDots % 3) + 1);
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  const dotsString = '. '.repeat(dots);

  return (
    <>{loadingText} {dotsString}</>
  )
}

export default LoadingDots